import { useApy } from '@ui/hooks/useApr';
import { useOneCoinUsdPrice } from '@ui/hooks/useCoinUsdValue';
import apyToApyList from '@ui/utils/apyToApyList';
import bigNumberToNumber from '@ui/utils/bigNumberToNumber';
import { format } from 'date-fns';
import { useMemo } from 'react';

export type RewardChartPoint = {
  apy: number;
  reward: number;
  date: string;
  usdReward: number;
};

const useRewardChartData = (amount: number): RewardChartPoint[] => {
  const { data: apy } = useApy();
  const { data: usdPrice } = useOneCoinUsdPrice();

  const apyList = useMemo(() => apyToApyList(apy), [apy]);
  const rewards = apyList.map((apy) => apy * amount);

  const now = new Date();
  const dates = [1, 6, 12, 24]
    .map((months) => addMonths(now, months))
    .map((date) => format(date, 'yyyy - MM - dd'));

  const usdRewards = usdPrice
    ? rewards.map((reward) => reward * bigNumberToNumber(usdPrice))
    : Array.from({ length: 4 }).map((_) => 0);

  return apyList.map((apy, i) => {
    return {
      apy,
      reward: rewards[i],
      date: dates[i],
      usdReward: usdRewards[i],
    };
  });
};

const addMonths = (date: Date, months: number) => {
  const copyDate = new Date(date);
  copyDate.setMonth(date.getMonth() + months);

  return copyDate;
};

export default useRewardChartData;
